import { RestClient } from "clients/rest";
import { PageableResponse } from "../PageableResponse";

export type B090012FindRequest = {
  sokoCd: string;
  shohinCd: string;
} & Partial<{
  torihikiYmdFrom: string;
  torihikiYmdTo: string;
  page: number;
  sort: string[];
  size: number;
}>;

export type B090012FindResponse = {
  crtDate: string;
  shainNm: string;
  ukeharaiKbnNm: string;
  ukeiresu: string;
  haraidashisu: string;
  hikiatesu: string;
  denpyoNo: string;
  torihikiYmdView: string;
  aitesakisokoCd: string;
  aitesakisokoNmr: string;
  meisaibiko: string;
};

export const B090012Find = (props: B090012FindRequest) => {
  return RestClient.get<PageableResponse<B090012FindResponse[]>>(
    "b090012/find",
    {
      params: props,
    }
  );
};
